import "./Homepage.css";
import { useRef } from "react";
import { Button } from "antd"; //https://ant.design/components/button
import { FileUploader } from "react-drag-drop-files"; //https://www.npmjs.com/package/react-drag-drop-files
import ScrollToTop from "../ScrollToTop/ScrollToTop";
// import Greetings from "../Greetings/Greetings";

function Homepage({ handleChange, sample }) {
  const fileTypes = ["PDF"];
  const getStartedRef = useRef(null);
  const about = useRef(null);

  const scrollToGetStarted = () => {
    if (getStartedRef.current) {
      getStartedRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToAbout = () => {
    if (about.current) {
      about.current.scrollIntoView({ behavior: "smooth" });
    } else {
      // console.log("About ref not working");
    }
  };

  return (
    <div className="home-page-boss">
      <div className="home-page-container">
        <div className="logo">
          <div className="glassy">
            <img src="./title2.png" alt="Language Lens" className="title"></img>
            <div className="file-upload">
              <FileUploader
                handleChange={handleChange}
                name="file"
                types={fileTypes}
              />
              <p>or</p>
              <Button className="sample-button" type="primary" onClick={sample}>
                Go To The App With A Sample PDF
              </Button>
            </div>
          </div>
        </div>

        <div className="nav">
          <div className="nav-buttons">
            <button onClick={scrollToGetStarted}>Get Started</button>
            <button onClick={scrollToAbout}>Tech Stack</button>
          </div>
        </div>
      </div>

      <div className="get-started-container" ref={getStartedRef}>
        <div className="get-started-left">
          <h2 className="get-started-title">Get Started</h2>
          <h1 className="get-started-header">
            Upload a PDF File You Wish To Translate
          </h1>
          <p className="get-started-body">
            Learning a new language through real-world materials like PDFs can
            be challenging. Our tool simplifies the process by letting you
            easily select and translate text passages from any PDF, even if the
            text isn't selectable or copying it results in errors. Upload your
            document and start learning today!
          </p>
        </div>
        <div className="get-started-right file-upload">
          <FileUploader
            handleChange={handleChange}
            name="file"
            types={fileTypes}
          />
          <p>or</p>
          <Button className="sample-button" type="primary" onClick={sample}>
            Go To The App With A Sample PDF
          </Button>
        </div>
      </div>

      <div className="tech-container" ref={about}>
        <h2 className="tech-stack-title">Tech Stack</h2>
        <div className="tech-cards">
          <div className="gemini-card">
            <div className="gemini-logo">
              <img src="./gemini.jpg" alt="gemini"></img>
            </div>
            <div className="gemini-text">
              <h1>Google Gemini</h1>
              <p>image to text translation</p>
            </div>
          </div>
          <div className="gemini-card">
            <div className="gemini-logo">
              <img
                className="firebase-image"
                src="./firebase.jfif"
                alt="firebase"
              ></img>
            </div>
            <div className="gemini-text">
              <h1>Firebase</h1>
              <p>Hosting and Gemini API access</p>
            </div>
          </div>
          <div className="gemini-card">
            <div className="gemini-logo">
              <img src="./react.png" alt="react js"></img>
            </div>
            <div className="gemini-text">
              <h1>React JS</h1>
              <p>Front End Framework</p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-container">
        <div className="footer">
          <div className="author">
            <img
              src="./title2.png"
              alt="Language Lens"
              className="footer-logo"
            ></img>
            <div className="gemini-text author-text">
              <p>By: Jordon Dao</p>
            </div>
          </div>
          <div className="contact">
            <div className="gemini-text author-text">
              <p>Contact</p>
              <p>Email: jordon.dao@hotmail.com</p>

              <p>Portfolio: </p>
              <a
                href="https://main.d1nuzj2j44n21h.amplifyapp.com/"
                className="portfolio-link"
              >
                https://main.d1nuzj2j44n21h.amplifyapp.com/
              </a>
            </div>
          </div>
          <div className="contact">
            <div className="gemini-text author-text">
              <p>LinkedIn: </p>
              <a
                href="https://www.linkedin.com/in/jordon-luc-dao-40aa3126b/"
                className="portfolio-link"
              >
                https://www.linkedin.com/in/jordon-luc-dao-40aa3126b/
              </a>

              <p>Github: </p>
              <a href="https://github.com/jDaowy" className="portfolio-link">
                https://github.com/jDaowy
              </a>
            </div>
          </div>
        </div>
      </div>

      <ScrollToTop />
    </div>
  );
}

export default Homepage;
